import { render, staticRenderFns } from "./marketTzEdit.vue?vue&type=template&id=35a29e61&scoped=true"
import script from "./marketTzEdit.vue?vue&type=script&lang=js"
export * from "./marketTzEdit.vue?vue&type=script&lang=js"
import style0 from "./marketTzEdit.vue?vue&type=style&index=0&id=35a29e61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a29e61",
  null
  
)

export default component.exports